import { FC } from 'react';
import { GetStaticComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentRendering, LayoutServiceData } from '@sitecore-jss/sitecore-jss-react';
import dynamic from 'next/dynamic';
import { GetStaticPropsContext } from 'next/types';

import { fetchColorHexMappings } from 'api/colorHexMappingApi';
import { ProductFilterModuleProps } from 'composables/Product/ProductFilterModule/productFilterModuleTypes';
import { loadPimSfccMappings } from 'composables/Product/ProductFilterModule/utils/loadPimSfccMappings';
import getConfig from 'temp/config';

const ProductFilterModuleComposable = dynamic(
  () => import('composables/Product/ProductFilterModule/ProductFilterModuleSpot'),
  {
    ssr: true,
    loading: () => <div className="h-96 w-full animate-pulse bg-gray-100" />,
  }
);

const ProductFilterModuleSpot: FC<ProductFilterModuleProps> = (props) => {
  return <ProductFilterModuleComposable {...props} />;
};

export const getStaticProps: GetStaticComponentProps = async (
  _: ComponentRendering,
  __: LayoutServiceData,
  context: GetStaticPropsContext
) => {
  const { productCatalogueBaseUrl } = getConfig();
  const colorHexMappings = await fetchColorHexMappings(context.locale);

  let pimSfccMappings = {};

  try {
    pimSfccMappings = await loadPimSfccMappings();
  } catch (error) {
    console.warn('Failed to load PIM SFCC mappings:', error);
  }

  return {
    productCatalogueApi: productCatalogueBaseUrl,
    colorHexMappings,
    pimSfccMappings,
  };
};

export default ProductFilterModuleSpot;
